import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { VrLineHeight } from '../../../../theming/verticalRhythm/verticalRhythm';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';

export const footerSectionPadding = (vrLineHeight: VrLineHeight) => (
  {
    [MEDIA_BREAKPOINTS.X_LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE]}px 0`,
    },
    [MEDIA_BREAKPOINTS.LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px 0`,
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px 0`,
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px 0`,
    },
  }
);

export const generateSeparatorSections = (separatorStyle: object) => (acc: React.ReactElement<any>[], section: React.ReactElement<any> | null, index: number, arr: (React.ReactElement<any> | null)[]) => {
  const res = section as React.ReactElement<any>;
  return index < arr.length - 1 ? [...acc, res, <div key={index} className={css(separatorStyle)} />] : [...acc, res];
};
